import React, { Component } from 'react';
import * as LA_DOWNTOWN_DELIVERY_REGION from '../../../utils/googleMapRegions';
import * as GIFT_DELIVERY_REGIONS from '../../../utils/giftDeliveryRegions';
import * as GoogleAPI from '../../../utils/googleApiHelper';

const DEFAULT_LOCATION = {
    lat: -34.397,
    lng: 150.644
}
const DEFAULT_MAP_ZOOM = 14;

const laDownTownDNDPolygon = new google.maps.Polygon({
    paths: [
        LA_DOWNTOWN_DELIVERY_REGION.REGION_NO_DELIVERY1,
        LA_DOWNTOWN_DELIVERY_REGION.REGION_NO_DELIVERY2
    ],
    strokeColor: '#db3636',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#db3636',
    fillOpacity: 0
});

const laDownTownBikePolygon = new google.maps.Polygon({
    paths: LA_DOWNTOWN_DELIVERY_REGION.REGION_BIKE_DELIVERY,
    strokeColor: '#62af44',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#62af44',
    fillOpacity: 0
});

const laDownTownCarPolygon = new google.maps.Polygon({
    paths: LA_DOWNTOWN_DELIVERY_REGION.REGION_CAR_DELIVERY,
    strokeColor: '#7C3592',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#7c3592',
    fillOpacity: 0
});

const giftDeliverySameDayPolygon = new google.maps.Polygon({
    paths: GIFT_DELIVERY_REGIONS.GIFT_SAME_DAY_DELIVERY,
    strokeColor: '#62af44',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#62af44',
    fillOpacity: 0
});

const giftDeliveryDaysNoticePolygon = new google.maps.Polygon({
    paths: [GIFT_DELIVERY_REGIONS.GIFT_DAYS_NOTICE_DELIVERY_1, GIFT_DELIVERY_REGIONS.GIFT_DAYS_NOTICE_DELIVERY_2],
    strokeColor: '#c6a4cf',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#c6a4cf',
    fillOpacity: 0
});

const laSilverlakeCarPolygon = new google.maps.Polygon({
    paths: LA_DOWNTOWN_DELIVERY_REGION.SILVERLAKE_CAR_DELIVERY,
    strokeColor: '#3c1dc4',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#3c1dc4',
    fillOpacity: 0
});

export const validateLatLngLADownTown = (latLng) => {
    const isInLADownTownDNDPolygon = google.maps.geometry.poly.containsLocation(latLng, laDownTownDNDPolygon);
    const isInLADownTownBikePolygon = google.maps.geometry.poly.containsLocation(latLng, laDownTownBikePolygon);
    const isInLADownTownCarPolygon = google.maps.geometry.poly.containsLocation(latLng, laDownTownCarPolygon);

    if((isInLADownTownBikePolygon || isInLADownTownCarPolygon) && (!isInLADownTownDNDPolygon)) {
        return {
            region:'LA_DOWNTOWN',
            status: true,
            time: 0
        };
    } 
    return {
        region:'LA_DOWNTOWN',
        status: false,
        time: 0
    };
};

export const validateLatLngSilverlake = (latLng) => {
    const isInSilverlakeCarPolygon = google.maps.geometry.poly.containsLocation(latLng, laSilverlakeCarPolygon);
    if(isInSilverlakeCarPolygon) {
        return {
            region:'LA_SILVERLAKE',
            status: true,
            time: 0
        };
    } 
    return {
        region:'LA_SILVERLAKE',
        status: false,
        time: 0
    };
};

/**
 * This is being used for both gift deliveries
 * & normal deliveries in extended areas
 * originally it was intended for gift deliveries only
 * UGLY HACK due to the following requirements:
 *  - For non gift deliveries - Remove 1 day delivery,
        Both Delivery zones will be 2 day deliveries.
        SilverLake region now added for instant delivery
 */
export const validateLatLngLAGift = (latLng) => {
    const LADownTownDeliveryValidationStatus = validateLatLngLADownTown(latLng);
    const LASilverlakeDeliveryValidationStatus = validateLatLngSilverlake(latLng);
    if(LASilverlakeDeliveryValidationStatus.status) {
        return  {
            region:'LA_SILVERLAKE',
            status: true,
            time: 2,
            timeDisplay: '2 hours',
        }
    }
    if(LADownTownDeliveryValidationStatus.status) {
        return  {
            region:'LA_DOWNTOWN',
            status: true,
            time: 2,
            timeDisplay: '2 hours',
        }
    }
    const isInGiftDeliverySameDayPolygon = google.maps.geometry.poly.containsLocation(latLng, giftDeliverySameDayPolygon);
    const isInGiftDeliveryDaysNoticePolygon = google.maps.geometry.poly.containsLocation(latLng, giftDeliveryDaysNoticePolygon);
    if(isInGiftDeliverySameDayPolygon) {
        return  {
            region:'LA_GIFT_SAME_DAY',
            status: true,
            time: 24,
            timeDisplay: '1 day'
        };
    }

    if(isInGiftDeliveryDaysNoticePolygon) {
        return  {
            region:'LA_GIFT_DAYS_NOTICE',
            status: true,
            time: 48,
            timeDisplay: '2 days'
        };
    }

    return {
        region: 'SHIPPO',
        status: true,
        time: 0,
    }
}

export const validateLatLongForDelivery = (latLng, deliveryValidation) => {
    let deliveryValidationStatus = {
        region:'NA',
        status: true,
        time: 0
    }; // return this default value if there is no deliveryValidation needed.
    const latLngObj = new google.maps.LatLng(latLng)
    if (deliveryValidation === 'NORMAL') {
        deliveryValidationStatus =  validateLatLngLADownTown(latLngObj);
    } else if(deliveryValidation === 'GIFT') {
        deliveryValidationStatus = validateLatLngLAGift(latLngObj);
    } 
    return deliveryValidationStatus;
};

class PlacePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apartment: '',
            place: null,
            deliveryStatus: true
        };
        this.initGoogleAutoSuggest = this.initGoogleAutoSuggest.bind(this);
        this.initGoogleAutoCompleteService = this.initGoogleAutoCompleteService.bind(this);
        this.initDeliveryPolygons = this.initDeliveryPolygons.bind(this);
        this.initMap = this.initMap.bind(this);
        this.submitAddress = this.submitAddress.bind(this);
        this.autoComplete = null;
        this.placeChangeListener = null;
    }

    componentDidMount() {
        this.initGoogleAutoSuggest();
    }

    componentWillUnmount() {
        if (this.autoComplete) {
            google.maps.event.removeListener(this.placeChangeListener);
            google.maps.event.clearInstanceListeners(this.autocompleteElement);
            document.querySelector('.pac-container').remove();
        }
    }

    render() {
        const {place, deliveryStatus} = this.state;
        return (
            <div className="place-picker-component">
                <div className="row">
                    <div className="col-md-12">
                        <input placeholder="Search address..." aria-label="Search address" className="address-search-input" ref={(elem) => this.autocompleteElement = elem} />
                    </div>
                    <div className={`col-md-12 invisible`}>
                        <div className="address-map" ref={(elem) => this.mapElement = elem}></div>
                    </div>

                </div>
                {!deliveryStatus?
                    <div className="row">
                        <div className="col-md-12">
                            <p className="text-error">We cannot deliver to this location. Please search for another address.</p>
                        </div>
                    </div>
                    :null
                }
                {place
                    ? (<div>
                        <div className="row">
                            <div className="col-md-12">
                                <input maxLength="12" aria-label="Apartment # (Optional)" placeholder="Apartment # (Optional)" className="" value={this.state.apartment} onChange={(e) => this.setState({ apartment: e.target.value })} />
                                {this.state.apartment && this.state.apartment.length === 12 && <div className="error-text">Apartment No. should be less than 12 characters.</div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="footer-container text-center">
                                    <button className="btn btn-block" onClick={this.submitAddress}>SUBMIT</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    )
                    : null
                }
            </div>
        );
    }

    initGoogleAutoSuggest() {
        this.initMap(this.mapElement);
        this.initGoogleAutoCompleteService(this.autocompleteElement, (place) => {
            this.setState({ place: place });
        });
        this.initDeliveryPolygons();
    }

    initMap(element, options) {
        this.map = new google.maps.Map(element, {
            center: options && options.center
                ? options.center
                : DEFAULT_LOCATION,
            zoom: options && options.zoom
                ? options.zoom
                : DEFAULT_MAP_ZOOM
        });
    }

    initGoogleAutoCompleteService(inputElement, eventHandler) {
        if (!this.autoComplete) {
            this.autoComplete = new google.maps.places.Autocomplete(inputElement);
            this.placeChangeListener = this.autoComplete.addListener('place_changed', () => {
                let place = this.autoComplete.getPlace();
                if (place.geometry) {
                    eventHandler(place);
                }
            });
        }
    }

    initDeliveryPolygons() {
        laDownTownDNDPolygon.setMap(this.map);
        laDownTownBikePolygon.setMap(this.map);
        laDownTownCarPolygon.setMap(this.map);
        giftDeliverySameDayPolygon.setMap(this.map);
        giftDeliveryDaysNoticePolygon.setMap(this.map);
    }

    submitAddress() {
        const {onSubmit, deliveryValidation} = this.props;
        const place = this.state.place;
        const latLng = this._getLocationByPlace(place);
        const deliveryValidationStatus = validateLatLongForDelivery(latLng, deliveryValidation);
        const country = GoogleAPI.extractFromAddress(place.address_components, 'country', 'short_name');
        const houseNumber = GoogleAPI.extractFromAddress(place.address_components,"street_number");
        const streetRoute = GoogleAPI.extractFromAddress(place.address_components,"route");
        let street = houseNumber && streetRoute ? `${houseNumber} ${streetRoute}` : null;
        street = street ? street : streetRoute;
        const city = GoogleAPI.extractFromAddress(place.address_components, 'locality');
        const state = GoogleAPI.extractFromAddress(place.address_components, 'administrative_area_level_1', 'short_name');
        const zip = GoogleAPI.extractFromAddress(place.address_components, 'postal_code');
        let placeName = place.name ? place.name.trim() : '';
        let formattedAddress = place.formatted_address;
        const placeNameExistence = formattedAddress.indexOf(placeName);

        if (placeName && placeNameExistence != 0) {
            formattedAddress = placeName + ', ' + formattedAddress;
        }
        const address = {
            description: formattedAddress,
            loc: [latLng.lng, latLng.lat],
            apartment: this.state.apartment,
            street,
            city,
            state,
            zip,
            country,
        };
        if (country === 'US' || country === 'United States') {
            onSubmit(address, deliveryValidationStatus);
        } else {
            this.setState({deliveryStatus: false})
        }
    }

    _getLocationByPlace(place) {
        if (place && place.geometry) {
            let latitude = (typeof place.geometry.location.lat === 'number')
                ? place.geometry.location.lat
                : place.geometry.location.lat();
            let logitude = (typeof place.geometry.location.lng === 'number')
                ? place.geometry.location.lng
                : place.geometry.location.lng();
            return { lat: latitude, lng: logitude }
        } else {
            return null;
        }
    }

}

export default PlacePicker;


// WEBPACK FOOTER //
// ./src/components/commons/place-picker/PlacePicker.js